export default __webpack_public_path__ + "calendar-with-spring-binder-and-date-blocks.png";